import { useMutation } from '@tanstack/react-query';
import { deleteComment } from '../queries/comments';

const useDeleteComment = () => {
  const { mutate, isPending, isSuccess } = useMutation({
    mutationKey: ['delete-comment'],
    mutationFn: deleteComment,
  });

  return { mutate, isPending, isSuccess };
};

export default useDeleteComment;
